export class FileModel {
  public fileId: number;
  public fileContent: any;
  public fileType: string;
  public fileName: string;
  public fileSizeInBytes: number;
  public medicineLeafletTypeId: number;
}